import { render } from "./ProjectItem.vue?vue&type=template&id=0d7645c2&scoped=true"
import script from "./ProjectItem.vue?vue&type=script&lang=js"
export * from "./ProjectItem.vue?vue&type=script&lang=js"

import "./ProjectItem.vue?vue&type=style&index=0&id=0d7645c2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d7645c2"]])

export default __exports__